<template lang="pug">
 
  v-col( cols=12 :md='seleccionado ? 12 : 4'  height='100%')
   
      v-card.d-flex.flex-column.fill-height( tile  :to='!seleccionado ? {name: "novedades", params: {articulo: item.titulo }} : null' :class='!seleccionado ? "blue-grey lighten-5": "white"')
        v-card(v-if='!seleccionado' flat tile)
          v-hover( v-slot:default='{hover}')
            v-img( :src='item.imagenes[0]' cover height='250px' :elevation='hover && !seleccionado? 12 : 0' )
        v-carousel( v-else width='5vh' hide-delimiter-background='' show-arrows-on-hover='' )  
          v-carousel-item(v-for='imagen, k of item.imagenes' :key='k' ).fill-height
            
            iframe( v-if='imagen && imagen.indexOf("youtube") > -1' width="100%"  :src="imagen" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
            v-img(v-else :src='imagen' contain height='100%').fill-height
        v-card-text( )
          div.azul--text( :class='seleccionado ? "text-left" : " subtitle-1 text-center "') {{item.subtitulo}} 
          div.font-weight-bold.rojo--text( :class='seleccionado ? "display-1 text-left" : "title text-center "') {{item.titulo}} 

          div.black--text.my-2( :class='seleccionado ? "text-left" : "text-center"') {{item.fecha}} 
          div.body-2.text-justify.grey--text.text--darken-2.mt-3(:class='!seleccionado ? "": "subtitle-1"' v-html='seleccionado ? item.contenido : item.resumen')   
      
      
  
</template>
<script>
export default {
  data: ()=>({
  }),
  props: {
    item: Object,
    seleccionado: Boolean
  },
  computed: {
    Novedades() {
      return this.$contenido.Novedades || {}
    },

  },
}
</script>